import { DEL, GET, POST, PUT, setAuthToken } from "../config/ApiConfig";
import { decryptData, encryptData } from "../helpers/EncryptHelper";
import { apiError } from "../helpers/ErrorHelper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dateFormat from "dateformat";
import config from "../config/config";
import { getCurrentFinancialYear } from "./MasterModel";

const module = {
    endPoint: '/reports',
    key: 'reports'
};

export const getReport = async(param = {}) => {
    let user_token = param.user_token;
    if (!user_token) {
       return [];
    }
    // let page = param.page ? param.page : 1;
    // let limit = param.limit ? param.limit : 10;
    // delete param.page;
    // delete param.limit;
    let query = new URLSearchParams(param).toString();
    let month = param.month || '';
    let date = param.date || '';
    try {
        setAuthToken(user_token);
        const url = `${module.endPoint}/client-report/?${query}`;
        const response = await GET(url);
        if (!response.status) {
            toast.error(response.message);
        }
        return response.data;
    } catch (error) {
        apiError(error);
        console.log(error);
    }
}

export const getMonthsList = async (param = {}) => {
    let user_token = param.user_token;
    if (!user_token) {
        return [];
    }

    const queryParam = { ...param };
    delete queryParam.user_token;
    if (queryParam._fin_year_id == null || queryParam._fin_year_id === "") {
        const fin = getCurrentFinancialYear();
        if (fin && typeof fin === "object" && fin._fin_year_id) {
            queryParam._fin_year_id = fin._fin_year_id;
        }
    }

    const query = new URLSearchParams(queryParam).toString();

    try {
        setAuthToken(user_token);
        const url = query
            ? `${module.endPoint}/get-months-list?${query}`
            : `${module.endPoint}/get-months-list`;
        const response = await GET(url);
        if (!response.status) {
            toast.error(response.message);
        }
        return response.data;
    } catch (error) {
        apiError(error);
        console.log(error);
    }
};

export const getMonthlyReport = async (param = {}) => {
    let user_token = param.user_token;
    let month = param.month || '';
    let date = param.date || '';
    try {
        setAuthToken(user_token);
        const url = `${module.endPoint}/get-monthly-reports?month=${month}&date=${date}`;
        const response = await GET(url);
        if (!response.status) {
            toast.error(response.message);
        }
        return response.data;
    } catch (error) {
        apiError(error);
        console.log(error);
    }
};

export const getDashboardCounts = async (param = {}) => {
    let user_token = param.user_token;
    // let from_date = param.from_date;
    // let to_date = param.to_date;
    let month = param.month || null;
    
     try {
        setAuthToken(user_token);
        const url = `${module.endPoint}/get-dashboard-data?month=${month}`;
        //const url = `${module.endPoint}/get-dashboard-data?from_date=${from_date}&to_date=${to_date}`;
        const response = await GET(url);
        if (!response.status) {
            toast.error(response.message);
        }
        return response.data;
    } catch (error) {
        apiError(error);
        console.log(error);
    }
};

/** AM progress: meetings logged and action status by account manager for a month. */
export const getAmDashboardData = async (param = {}) => {
    let user_token = param.user_token;
    let month = param.month || null;

    try {
        setAuthToken(user_token);
        const url = `${module.endPoint}/get-am-dashboard-data?month=${month || ""}`;
        const response = await GET(url);
        if (!response.status) {
            toast.error(response.message);
        }
        return response.data;
    } catch (error) {
        apiError(error);
        console.log(error);
    }
};

/** Super admin: top / bottom users by login session count for a month. */
export const getSessionLoginDashboardData = async (param = {}) => {
    const user_token = param.user_token;
    const month = param.month || "";

    if (!user_token) {
        return null;
    }

    try {
        setAuthToken(user_token);
        const limit = param.limit ? `&limit=${param.limit}` : "";
        const url = `${module.endPoint}/get-session-login-dashboard?month=${month}${limit}`;
        const response = await GET(url);
        if (!response.status) {
            if (response.message) {
                toast.error(response.message);
            }
            return null;
        }
        return response.data;
    } catch (error) {
        apiError(error);
        console.log(error);
        return null;
    }
};